import React from 'react';

import { TranslateBadge } from '@travel/icons/ui';
import type { ProviderInformation } from '@travel/traveler-core/types/providerInformation';

import styles from './basicInformation.module.scss';

export default function GoogleTranslate(props: { provider: ProviderInformation }) {
  const { provider } = props;
  if (!provider.isDescriptionGoogleTranslated) {
    return null;
  }

  return (
    <p className={styles.descriptionTranslated}>
      <TranslateBadge data-testid="basicInformation-providerDescription-translateBadge" />
    </p>
  );
}
